import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./cfdi-types_style.css";
import { FaUndo } from "react-icons/fa";

function DeletedCFDITypes ({ setUpdateTrigger, updateTrigger }) {

    const [deletedCfdiTypes, setDeletedCfdiTypes] = useState([]);

    const getDeletedCFDITypes = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/cfdis/getAllDeleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedCfdiTypes(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
        }
    };

    const restoreCFDIType = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar este tipo de CFDI?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/cfdis/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedCFDITypes();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedCFDITypes();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Tipos de CFDI eliminados</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Código</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedCfdiTypes.map((cfditype) => (
                        <tr key={cfditype.id} data-master-id={cfditype.id}>
                            <td>{cfditype.name}</td>
                            <td>{cfditype.code}</td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restoreCFDIType(cfditype.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedCFDITypes;